import { gql } from 'urql';

const UPDATE_ACTION_FILE = gql`
  mutation UpdateActionFile(
    $fileId: Int!
    $_set: action_files_set_input!
    $id: Int!
    $activity: String
    $timestamp: bigint
    $userId: Int
  ) {
    update_action_files_by_pk(pk_columns: { id: $fileId }, _set: $_set) {
      id
    }

    insert_actions_activity_one(
      object: { activity: $activity, entity_id: $id, timestamp: $timestamp, user_id: $userId }
    ) {
      id
    }
  }
`;

export default UPDATE_ACTION_FILE;
